export enum UserRole {
  ITAdmin = 3,
  AOAdmin = 9,
  OfqualQualAdmin = 1,
  OfqualAccreditationAdmin = 2,
  AoQualAdmin = 7,
  CceaQualAdmin = 5,
  CceaAccreditationAdmin = 6
}

export const ManageUnitRoles = [
  UserRole.ITAdmin,
  UserRole.OfqualQualAdmin,
  UserRole.OfqualAccreditationAdmin,
  UserRole.CceaAccreditationAdmin,
  UserRole.AOAdmin,
  UserRole.AoQualAdmin,
  UserRole.CceaQualAdmin
];